import Api from "./Api";
import Utils from "../utilities/Utils";
import {
  Article,
  ArticleCollection,
  FeaturedArticle,
  HelpCenter,
} from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class HelpCentersController extends Api {
  static getHelpCenter(id: string) {
    return fetch(`/api/help_centers/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getHelpCenters(params: object) {
    return fetch(`/api/help_centers?${SearchHelper.getQueryString(params)}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static create(help_center: HelpCenter) {
    return fetch("/api/help_centers", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ help_center: help_center }),
    }).then((res) => res.json());
  }

  static update(help_center: HelpCenter) {
    return fetch(`/api/help_centers/${help_center.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ help_center: help_center }),
    }).then((res) => res.json());
  }

  static delete(id: string) {
    return fetch(`/api/help_centers/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static bulkDelete(helpCenterIds: string[]) {
    return fetch(`/api/help_centers/bulk_delete`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ help_center_ids: helpCenterIds }),
    }).then((res) => res.json());
  }

  static getForm(params: {
    id?: string;
  }): Promise<{ help_center: HelpCenter }> {
    return fetch(`/api/help_centers/form?${Utils.encodeQueryData(params)}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getView(
    helpCenterId: string,
    params = {}
  ): Promise<{
    help_center: HelpCenter;
    article_collections: ArticleCollection[];
    articles: Article[];
    featured_articles: FeaturedArticle[];
  }> {
    return fetch(
      `/api/help_centers/${helpCenterId}/view?${Utils.encodeQueryData(params)}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }
}
